import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { Lodging } from "@b2bportal/lodging-api";
import {
  HotelShopMap,
  HotelShopSection,
  useAboutHotelSection,
} from "@tenant/hotels";
import { Dialog, DialogContent, DialogTrigger } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./AboutHotelSection.module.scss";

export interface AboutHotelSectionComponentProps
  extends PlatformComponentProps {
  hotel: Lodging;
}

const COMPONENT_KEY = CoreHotelsComponent.AboutHotelSection;
export const AboutHotelSection = (props: AboutHotelSectionComponentProps) => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { children, className } = props;

  const { context, text } = useAboutHotelSection(props);

  return (
    <HotelShopSection className={clsx(block, className)} title={text.title}>
      <div className={cn("content")}>{text.content}</div>

      <Dialog>
        <DialogTrigger className={cn("read-more")}>
          {text.readMore}
        </DialogTrigger>
        <DialogContent title={text.title}>
          <p className={cn("dialog-content")}>{text.content}</p>
        </DialogContent>
      </Dialog>

      <HotelShopMap hotel={context.hotel} />
      {children}
    </HotelShopSection>
  );
};
